import { useSelector } from "react-redux";
import { useConectividadApi } from "./service";
import { errorMessages } from "../components/messages/commonMessages";

export const useOficinaService = () => {
  const { serverData } = useConectividadApi();
  const session = useSelector((state) => state.session);

  /**
   * @methodApi get.
   * @description  Método encargado de obtener una lista de oficinas
   */
  const getOficinas = async () => {
    try {
      const options = {
        method: "GET",
        url: "/oficina",
        headers: {
          Authorization: `Bearer ${session.credentials.accessToken}`,
        },
      };
      return await serverData(options).then((response) => {
        let data = response;
        if (data) {
          return data;
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  /**
   * @methodApi get.
   * @description  Método encargado de obtener una lista de oficinas segun facturador
   */
  const getOficinasFacturador = async (idFacturador = "-1") => {
    try {
      const options = {
        method: "GET",
        url: `/oficina/facturador/${idFacturador}`,
        headers: {
          Authorization: `Bearer ${session.credentials.accessToken}`,
        },
      };
      return await serverData(options).then((response) => {
        let data = response;
        if (data) {
          return data;
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  /**
   * @methodApi v.
   * @description  Método encargado de obtener los facturadores
   */
  const getFacturadores = async () => {
    try {
      const options = {
        method: "GET",
        url: "/oficina/facturadores",
        headers: {
          Authorization: `Bearer ${session.credentials.accessToken}`,
        },
      };
      return await serverData(options).then((response) => {
        let data = response;
        if (data) {
          return data;
        }
      });
    } catch (error) {
      let { data } = error;
      alert(data.msg);
    }
  };

  /**
   * @methodApi post.
   * @description  Método encargado de crear oficinas
   */
  const post = async (values) => {
    let result = {};
    try {
      const options = {
        method: "POST",
        url: "/oficina",
        headers: {
          Authorization: `Bearer ${session.credentials.accessToken}`,
        },
        data: values,
      };

      try {
        let resultServer = await serverData(options);

        if (resultServer !== undefined) {
          if (resultServer?.code !== 409) {
            result = { success: true, message: "", data: {} };
          } else {
            result = { success: false, message: resultServer?.msg, data: [] };
          }
        } else {
          result = {
            success: false,
            message: errorMessages.SERVER_ERROR,
            data: [],
          };
        }
      } catch (error) {
        let { data } = error;
        result = { success: false, message: data.msg, data };
      }
    } catch (error) {
      let { data } = error;
      result = { success: false, message: data.msg, data };
    }
    return result;
  };
  /**
   * @methodApi v.
   * @description  Método encargado de actualizar oficinas
   */
  const put = async (oficinaId, values) => {
    let result = {};
    try {
      const options = {
        method: "PUT",
        url: `/oficina/${oficinaId}`,
        headers: {
          Authorization: `Bearer ${session.credentials.accessToken}`,
        },
        data: values,
      };
      try {
        let resultServer = await serverData(options);

        if (resultServer !== undefined) {
          if (resultServer?.code !== 409) {
            result = { success: true, message: "", data: {} };
          } else {
            result = { success: false, message: resultServer?.msg, data: [] };
          }
        } else {
          result = {
            success: false,
            message: errorMessages.SERVER_ERROR,
            data: [],
          };
        }
      } catch (error) {
        let { data } = error;
        result = { success: false, message: data.msg, data };
      }
    } catch (error) {
      let { data } = error;
      result = { success: false, message: data.msg, data };
    }
    return result;
  };

  /**
   * @methodApi v.
   * @description  Método encargado de eliminar oficinas
   */
  const patch = async (oficinaId) => {
    let result = {};
    try {
      const options = {
        method: "PATCH",
        url: `/oficina/${oficinaId}`,
        headers: {
          Authorization: `Bearer ${session.credentials.accessToken}`,
        },
      };
      try {
        let resultServer = await serverData(options);

        if (resultServer !== undefined) {
          if (resultServer?.code !== 409) {
            result = { success: true, message: "", data: {} };
          } else {
            result = { success: false, message: resultServer?.msg, data: [] };
          }
        } else {
          result = {
            success: false,
            message: errorMessages.SERVER_ERROR,
            data: [],
          };
        }
      } catch (error) {
        let { data } = error;
        result = { success: false, message: data.msg, data };
      }
    } catch (error) {
      let { data } = error;
      result = { success: false, message: data.msg, data };
    }
    return result;
  };

  return {
    //Api Parametros
    getOficinas,
    getOficinasFacturador,
    getFacturadores,
    post,
    put,
    patch,
  };
};
